export default "__VITE_ASSET__00acc3e8__"